export default "__VITE_ASSET__D30DyZUM__";